export const nameFormatError = 'ご登録できない文字が含まれています'
export const nameLengthError = '32文字以内で入力してください'
export const familyNameLengthError = 'ファミリー名は10文字以内で入力してください'
export const familyNameEmptyError = 'ファミリー名を入力してください'
export const nicknameLengthError = '8文字以内で入力してください'
export const nameEmptyError = 'お名前を入力してください'
export const firstnameEmptyError = 'お名前（名）を入力してください'
export const lastnameEmptyError = 'お名前（姓）を入力してください'
export const firstnameRubyEmptyError = 'お名前（メイ）を入力してください'
export const lastnameRubyEmptyError = 'お名前（セイ）を入力してください'
export const firstnameRubyFormatError = 'お名前（メイ）を全角カナで入力してください'
export const lastnameRubyFormatError = 'お名前（セイ）を全角カナで入力してください'
export const nicknameEmptyError = 'ニックネームを入力してください'
export const telFormatError = '半角数字10~11桁で入力してください'
export const emailEmptyError = 'メールアドレスを入力してください'
export const emailFormatError = 'メールアドレスを正しく入力してください'
export const emailLengthError = '255文字以内のメールアドレスをご利用ください'
export const emailConfirmError = '入力されたメールアドレスが一致しません'
export const passwordEmptyError = '半角8文字以上32文字以下の大文字を含む英数字で入力してください'

// ログイン画面用。今後仕様次第でパスワードが空の場合のエラーメッセージが「パスワードを入力してください」に統一されるかもしれない。
export const passwordEmptyErrorForLogin = 'パスワードを入力してください'
export const passwordFormatError = '半角8文字以上32文字以下の大文字を含む英数字で入力してください'
export const passwordLengthError = '半角8文字以上32文字以下の大文字を含む英数字で入力してください'
export const oldPasswordFormatError = '半角4文字以上32文字以下の英数字で入力してください'
export const loginPasswordLengthError = '半角4文字以上32文字以下の英数字で入力してください'
export const passwordConfirmError = '入力されたパスワードが一致しません'
export const browsePasswordEmptyError = '閲覧パスワードを入力してください'
export const browsePasswordFormatError = '閲覧パスワードを正しく入力してください'
export const zipcodeEmptyError = '郵便番号を7桁の半角数字で入力してください'
export const zipcodeFormatError = '正しい郵便番号を入力してください'
export const prefectureEmptyError = '都道府県を選択してください'
export const prefectureFormatError = '正しい都道府県を選択してください'
export const address1EmptyError = '市区町村を入力してください'
export const address2EmptyError = '番地を入力してください'
export const address1LengthError = '市区町村は64文字以内で入力してください'
export const address2LengthError = '番地は64文字以内で入力してください'
export const address3LengthError = '建物名・部屋番号などは64文字以内で入力してください'
export const birthEmptyError = '生年月日を選択してください'
export const birthFormatError = '不正な日付情報です'
export const yearFormatError = '不正な日付情報です'
export const yearEmptyError = '生年月日（年）を選択してください'
export const monthFormatError = '不正な日付情報です'
export const monthEmptyError = '生年月日（月）を選択してください'
export const sexEmptyError = '性別を選択してください'
export const sexFormatError = '選択肢の中から性別を指定してください'
export const relationshipEmptyError = 'お子さまとのご関係を選択してください'
export const relationshipFormatError = 'お子さまとのご関係を選択してください'
export const readFlagEmptyError = '購読設定を選択してください'
export const unpublishReasonEmptyError = '非掲載理由を入力してください'
export const unpublishReasonLengthError = '非掲載理由は200文字以内で入力してください'
export const photoNumberLengthError = '60件以内で入力してください'
export const photoNumberFormatError = '入力内容に半角英数字、ハイフン以外が含まれています'
export const uchinokoSettingEmptyError = '値を指定してください'
export const addCaptionsEmptyError = '写真に入れる文字を入力してください'
export const addCaptionsFormatError = 'ご利用できない文字が含まれています'
export const addCaptionsIndentionError = '改行はご利用できません'
export const addCaptionsLengthError = '30文字以内で入力してください'
export const ikkatsuCaptionEmptyError = '内容を入力してください'
export const ikkatsuCaptionFormatError = 'ご利用できない文字が含まれています'
export const ikkatsuCaptionLengthError = '半角文字のみの場合は17文字、全角文字が含まれる場合は12文字以内で入力してください'
export const inquiryCategoryEmptyError = 'お問い合わせ内容を選択してください'
export const inquiryContentEmptyError = 'お問い合わせ内容詳細を入力してください'
export const inquiryOrderNumberEmptyError = 'ご注文番号を入力してください'
export const inquiryOrderNumberFormatError = 'ご利用できない文字が含まれています'
export const inquiryOrderNumberLengthError = '8文字以内の数字で入力してください'
export const faqSearchLengthError = 'キーワードを2文字以上で入力してください'
export const schoolPassError = '半角英数字で入力してください'
export const schoolPassEmptyError = 'スクールパスを入力してください'

// Credit Card
export const creditError = {
  cardNumberEmptyError: 'クレジットカード番号は半角数字で入力してください',
  cardNumberFormatError: '有効なクレジットカード番号を入力してください',
  cardExpYearEmptyError: '有効期限（年）を選択してください',
  cardExpMonthEmptyError: '有効期限（月）を選択してください',
  expireError: '現在より後の年月を指定してください',
  securityCodeEmptyError: 'セキュリティコードは半角数字で入力してください',
  securityCodeFormatError: '適切なセキュリティーコードを入力してください'
}
